/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReviewCreateInfo
 */
export interface ReviewCreateInfo {
    /**
     * Human readable name of the review
     * @type {string}
     * @memberof ReviewCreateInfo
     */
    displayName: string;
    /**
     * Description of the review
     * @type {string}
     * @memberof ReviewCreateInfo
     */
    description?: string;
    /**
     * Number of primary entity instances included in the review
     * @type {number}
     * @memberof ReviewCreateInfo
     */
    size: number;
}

/**
 * Check if a given object implements the ReviewCreateInfo interface.
 */
export function instanceOfReviewCreateInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "size" in value;

    return isInstance;
}

export function ReviewCreateInfoFromJSON(json: any): ReviewCreateInfo {
    return ReviewCreateInfoFromJSONTyped(json, false);
}

export function ReviewCreateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewCreateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'size': json['size'],
    };
}

export function ReviewCreateInfoToJSON(value?: ReviewCreateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'description': value.description,
        'size': value.size,
    };
}

